// extracted by mini-css-extract-plugin
export default {"border":"header_border__b-3+9"};